import { defineStore } from 'pinia';

import { wallStructuresAPI } from '~/APIConnection';
import { WallStructure } from '~/models';

/** */
export const useWallStructuresStore = defineStore('wallStructures', {
  state: () => {
    return {
      selectedThickness: 0,
      selectedWallStructure: null as WallStructure | null,
      wallStructures: [] as WallStructure[],
    };
  },
  actions: {
    /** */
    async fetchWallStructures () {
      const API = wallStructuresAPI;
      const { data } = await API.wallStructuresControllerGetAllWallStructures();
      this.wallStructures = data.map((ws) => new WallStructure(ws));
    }
  }
});
